import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
// Form
import { Formik, Form } from 'formik';
// Hooks
import useFormDuuf from './useFormDuuf';
// Functions
import schema from './schema';
import defaultValues from './defaultValues';
// Fields
import TextField from './fields/TextField';
import TextAreaField from './fields/TextAreaField';
import ConsentField from './fields/ConsentField';
import FileUploadField from './fields/FileUploadField';
import SelectField from './fields/SelectField';
import MultiSelectField from './fields/MultiSelectField';
import DateField from './fields/DateField';
import SectionField from './fields/SectionField';
import CheckboxField from './fields/CheckboxField';
import RadioField from './fields/RadioField';
import CaptchaField from './fields/CaptchaField';
import NumberField from './fields/NumberField';
import NameField from './fields/NameField';
import AddressField from './fields/AddressField';
import WebsiteField from './fields/WebsiteField';
import ListField from './fields/ListField';
export const FormContext = React.createContext({});
export const FormProvider = FormContext.Provider;
export const FormConsumer = FormContext.Consumer;
export const FormDuuf = ({ id, language = 'nl', generate = true, scrollToConfirm = true, scrollTopOffset = 0, className = '', children, apiUrl, privacyUrl, privacyUrlPlacement, captchaSiteKey, defaultFields = {}, renderLoading, renderStatus, extraTypes = {}, loadingComponent: Loading, contentComponent: Content, graphqlData = {}, data = {}, yupSchema = {}, yupSchemaOnly = false, onSubmit = (values) => null, onSubmitDone = (values) => null }) => {
    var _a, _b, _c;
    let form = null;
    if (Object.keys(graphqlData).length > 0) {
        form = id ? graphqlData.edges.find(({ node }) => node.formId === id) : graphqlData.edges[0];
    }
    if (Object.keys(data).length > 0) {
        form = { node: data };
    }
    if (!form) {
        return null;
    }
    const formFields = ((_b = (_a = form.node.formFields) === null || _a === void 0 ? void 0 : _a.nodes) === null || _b === void 0 ? void 0 : _b.edges) || ((_c = form.node.formFields) === null || _c === void 0 ? void 0 : _c.nodes) || form.node.formFields;
    const [confirmMessage, setConfirmMessage] = React.useState('');
    const formRef = React.useRef(null);
    const [captchaFilled, setCaptchaFilled] = React.useState(!captchaSiteKey);
    const executeScrollToConfirm = () => {
        if (!formRef.current) {
            return;
        }
        window.scrollTo({
            top: formRef.current.offsetTop + scrollTopOffset,
            behavior: 'smooth'
        });
    };
    function parseStringToQueryString(input, values) {
        const regex = /{([^:]+):(\d+)}/g;
        const result = [];
        let match;
        while ((match = regex.exec(input)) !== null) {
            const [, key, value] = match;
            result.push(`${encodeURIComponent(key)}=${encodeURIComponent(values[`input_${value}`])}`);
        }
        return result.join('&');
    }
    const handleSubmit = async (event, values, actions) => {
        event.preventDefault();
        actions.setSubmitting(true);
        if (onSubmit) {
            onSubmit(values);
        }
        try {
            const formData = new FormData();
            Object.keys(values).forEach((key) => {
                if (!!values[key] && Array.isArray(values[key])) {
                    values[key].forEach((value) => {
                        formData.append(`${key}[]`, value);
                    });
                }
                else {
                    formData.append(key, values[key]);
                }
            });
            const request = await fetch(`${apiUrl ? apiUrl : form.node.apiURL}/submissions`, {
                method: 'POST',
                body: formData
            });
            const response = await request.json();
            if (response.is_valid === true) {
                setConfirmMessage(response.confirmation_message);
                actions.setStatus('done');
                const redirect = form.node.confirmations.find((message) => message.type === 'REDIRECT');
                if (redirect) {
                    const queryString = parseStringToQueryString(redirect.queryString, values);
                    window.location.href = `${redirect.url}?${queryString}`;
                }
                if (onSubmitDone) {
                    onSubmitDone(values);
                }
                setTimeout(() => {
                    if (scrollToConfirm) {
                        executeScrollToConfirm();
                    }
                }, 100);
            }
            else {
                actions.setStatus('error');
            }
        }
        catch (error) {
            actions.setStatus('error');
        }
        actions.setSubmitting(true);
    };
    return (_jsx("div", { className: className, ref: formRef, children: _jsx(Formik, { initialValues: {
                ...defaultValues(formFields),
                ...defaultFields
            }, onSubmit: async () => null, validationSchema: schema(formFields, yupSchema, yupSchemaOnly), children: (formik) => {
                if (formik.status === 'done') {
                    return (_jsx("div", { className: "form-duuf-confirm", children: renderStatus ? (renderStatus({ status: formik.status, content: confirmMessage })) : (
                        // @ts-ignore
                        _jsx(Content, { className: "form-duuf-confirm", content: confirmMessage })) }));
                }
                if (formik.status === 'error') {
                    return (_jsx("div", { className: "form-duuf-something-wrong", children: renderStatus ? (renderStatus({ status: formik.status })) : (
                        // @ts-ignore
                        _jsx(Content, { className: "form-duuf-something-wrong", content: "Er ging iets fout" })) }));
                }
                return (_jsx(FormProvider, { value: {
                        language,
                        fields: formFields,
                        formik,
                        form: form.node,
                        privacyUrl,
                        privacyUrlPlacement,
                        captchaSiteKey,
                        captchaFilled,
                        setCaptchaFilled,
                        reset: formik.handleReset,
                        extraTypes
                    }, children: _jsxs(Form, { id: `form_${form.node.formId}`, 
                        // @ts-ignore
                        onSubmit: (event) => handleSubmit(event, formik.values, formik), method: "post", children: [formik.isSubmitting && _jsx("div", { className: "form-duuf-loading", children: renderLoading ? renderLoading() : _jsx(Loading, {}) }), generate ? (_jsxs(_Fragment, { children: [_jsx(FormDuufGroup, {}), _jsx(FormDuufSubmit, {})] })) : (children)] }) }));
            } }) }));
};
export const FormDuufGroup = ({ showIds = [], hideIds = [] }) => {
    const context = useFormDuuf();
    const fields = context.fields.filter((field) => {
        if (showIds.length > 0 && showIds.indexOf(field.id) === -1) {
            return false;
        }
        if (hideIds.length > 0 && hideIds.indexOf(field.id) !== -1) {
            return false;
        }
        return true;
    });
    return (_jsx(_Fragment, { children: fields === null || fields === void 0 ? void 0 : fields.filter((field) => (field === null || field === void 0 ? void 0 : field.visibility.toLowerCase()) !== 'hidden').map((field) => (_jsx(FormDuufField, { id: Number(field === null || field === void 0 ? void 0 : field.id) }, field === null || field === void 0 ? void 0 : field.id))) }));
};
export const FormDuufField = ({ id }) => {
    const context = useFormDuuf();
    const field = prepareFormDuufField(id);
    if (!field.data) {
        return null;
    }
    const types = {
        ...{
            list: ListField,
            website: WebsiteField,
            address: AddressField,
            name: NameField,
            number: NumberField,
            text: TextField,
            email: TextField,
            phone: TextField,
            textarea: TextAreaField,
            consent: ConsentField,
            select: SelectField,
            multiselect: MultiSelectField,
            fileupload: FileUploadField,
            date: DateField,
            section: SectionField,
            checkbox: CheckboxField,
            radio: RadioField,
            captcha: CaptchaField
        },
        ...context.extraTypes
    };
    const type = field.data.type.toLowerCase();
    // @ts-ignore
    if (!types[type]) {
        return null;
    }
    // @ts-ignore
    const Component = types[type];
    return _jsx(Component, { hasError: field.hasError, formik: context.formik, fieldId: field.fieldId, data: field.data });
};
export const prepareFormDuufField = (id) => {
    const context = useFormDuuf();
    const data = context.fields.find((field) => field.id === id);
    if (!data) {
        return {
            data: {},
            hasError: true,
            fieldId: ''
        };
    }
    const fieldId = `input_${data.id}`;
    const meta = context.formik.getFieldMeta(fieldId);
    const hasError = meta.error && meta.touched;
    return {
        data,
        hasError,
        fieldId,
        meta
    };
};
export const FormDuufSubmit = () => {
    const context = useFormDuuf();
    const isValid = context.captchaFilled &&
        context.formik.isSubmitting === false &&
        Object.keys(context.formik.touched).length > 0 &&
        Object.keys(context.formik.errors).length === 0;
    return (_jsx("div", { className: "form-duuf-group form-duuf-group-submit", children: _jsx("span", { className: `form-duuf-submit${!isValid ? ' form-duuf-submit-disabled' : ''}`, children: _jsx("button", { type: "submit", disabled: !isValid, children: context.form.button.text }) }) }));
};
export default FormDuuf;
